import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { CandidateDetailFragment } from 'generated/resources/graphql'

import { SectionContent } from './SectionContent'

interface OutletContext {
  candidate: CandidateDetailFragment //CandidateCvFragment
}

const CandidateCvPage = () => {
  const { candidate } = useOutletContext<OutletContext>()

  return (
    <Box padding="s24">
      <SectionContent candidateId={candidate.id} />
    </Box>
  )
}

export default CandidateCvPage
